import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const BIC_PATTERN = /^([A-Z]{6}[A-Z2-9][A-NP-Z1-9])(X{3}|[A-WY-Z0-9][A-Z0-9]{2})?$/;

export function normalizeIban(value: string): string {
  return String(value || '').replace(/\s+/g, '').toUpperCase();
}

export function isValidBic(value: string): boolean {
  return BIC_PATTERN.test(String(value || '').trim().toUpperCase());
}

export function isValidIban(value: string): boolean {
  const iban = normalizeIban(value);
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{10,30}$/.test(iban)) return false;
  const rearranged = iban.substring(4) + iban.substring(0, 4);
  let remainder = 0;
  for (const char of rearranged) {
    const digits = /[A-Z]/.test(char) ? (char.charCodeAt(0) - 55).toString() : char;
    for (const digit of digits) {
      remainder = (remainder * 10 + Number(digit)) % 97;
    }
  }
  return remainder === 1;
}

export const bicValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = String(control.value || '').trim();
  if (!value) return null;
  return isValidBic(value) ? null : { bic: true };
};

export const ibanValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = String(control.value || '').trim();
  if (!value) return null;
  return isValidIban(value) ? null : { iban: true };
};

export const trimmedRequiredValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  return String(control.value == null ? '' : control.value).trim() ? null : { required: true };
};
